const actions = {
  GET_TOTAL_BILLERS: "GET_TOTAL_BILLERS",
  GET_TOTAL_BILLERS_SUCCESS: "GET_TOTAL_BILLERS_SUCCESS",
  GET_TOTAL_BILLERS_FAILED: "GET_TOTAL_BILLERS_FAILED",


 GET_CATEGORIES: "GET_CATEGORIES",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILED: "GET_CATEGORIES_FAILED",


  SEARCH_BILLERS: "SEARCH_BILLERS",
  SEARCH_BILLERS_SUCCESS: "SEARCH_BILLERS_SUCCESS",
  SEARCH_BILLERS_FAILED: "SEARCH_BILLERS_FAILED",
  CLEAR_SEARCH_BILLERS: "CLEAR_SEARCH_BILLERS",

  getTotalBillers: () => ({ type: actions.GET_TOTAL_BILLERS }),
  getTotalBillersSuccess: (data) => ({
    type: actions.GET_TOTAL_BILLERS_SUCCESS,
    payload: { data },
  }),
  getTotalBillersFailed: (error) => ({
    type: actions.GET_TOTAL_BILLERS_FAILED,
    payload: { error },
  }),

    getCategories: () => ({ type: actions.GET_CATEGORIES }),
  getCategoriesSuccess: (data) => ({
    type: actions.GET_CATEGORIES_SUCCESS,
    payload: { data },
  }),
  getCategoriesFailed: (error) => ({
    type: actions.GET_CATEGORIES_FAILED,
    payload: { error },
  }),

  // Unified search: billerId OR category OR channel
  searchBillers: ({ billerId, category, channel, page, limit }) => ({
    type: actions.SEARCH_BILLERS,
    payload: { billerId, category, channel, page, limit },
  }),
  searchBillersSuccess: (data) => ({
    type: actions.SEARCH_BILLERS_SUCCESS,
    payload: { data },
  }),
  searchBillersFailed: (error) => ({
    type: actions.SEARCH_BILLERS_FAILED,
    payload: { error },
  }),

  clearSearchBillers: () => ({ type: actions.CLEAR_SEARCH_BILLERS }),
};

export default actions;
